import { useEffect, useState } from "react";
import axios from "axios";

export const PUBLIC_TOOLS_API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/public/audio-tools`;
export const publicToolHeaders = (session) => session?.access_token
  ? { "X-Public-Tools-Token": session.access_token } : {};
export const mediaUrl = (path) => path ? `${process.env.REACT_APP_BACKEND_URL || ""}${path}` : "";

export const deletePublicSession = (kind, session) => {
  if (!session?.session_id) return;
  axios.delete(`${PUBLIC_TOOLS_API}/${kind}/${session.session_id}`, {
    headers: publicToolHeaders(session),
  }).catch(() => {});
};

export const usePublicToolsLimits = () => {
  const [limits, setLimits] = useState({
    ttl_seconds: 3600,
    audio: { max_bytes: null, max_seconds: null, chunk_bytes: 4 * 1024 * 1024, ttl_policy: "inactivity" },
    video: { max_bytes: 200 * 1024 * 1024, max_seconds: 600, formats: ["mp4", "mov", "mkv", "webm", "avi"] },
  });
  useEffect(() => {
    let alive = true;
    Promise.resolve(axios.get(`${PUBLIC_TOOLS_API}/limits`)).then((response) => {
      if (alive && response?.data?.audio && response?.data?.video) setLimits(response.data);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return limits;
};
